import { TFunction } from "i18next";
import { CaptureResponse } from "../../types/model/capture";
import { MethodsInput } from "../../types/model/methodsInput";

const MISSING_PARAM_REGEX = /methods_input (\d+) has no valid (\w+)/;

function getErrorMessage(error: unknown): string | undefined {
  const e = error as any;
  return e?.response?.data?.message ?? e?.data?.message ?? e?.message;
}

export function resolveMethodsInputError(
  error: unknown,
  captures: CaptureResponse[],
  methodsInputsByCapture: Record<number, MethodsInput[]>,
  t: TFunction,
): string | null {
  const match = MISSING_PARAM_REGEX.exec(getErrorMessage(error) ?? "");
  if (!match) return null;

  const inputId = Number(match[1]);
  const param = t(`calculations.methods-input.${match[2].replaceAll("_", "-")}`, {
    defaultValue: match[2],
  });

  for (const [captureId, inputs] of Object.entries(methodsInputsByCapture)) {
    const input = inputs.find((i) => i.id === inputId);
    if (!input) continue;

    const capture = captures.find((c) => c.id === Number(captureId));
    return t("calculations.methods.errors.missing-parameter", {
      capture: capture?.name ?? `#${captureId}`,
      input: input.name,
      param,
    });
  }

  return t("calculations.methods.errors.missing-parameter-unknown", {
    inputId,
    param,
  });
}